{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "วาง",
    "pasteAsPlaintext": "วางโดยไม่มีการจัดรูปแบบ",
    "pasteCharts": "วางแผนภูมิ",
    "chartType_bar": "",
    "chartType_line": "แผนภูมิเส้น",
    "chartType_radar": "",
    "chartType_plaintext": "ข้อความธรรมดา",
    "selectAll": "เลือกทั้งหมด",
    "multiSelect": "เพิ่มองค์ประกอบในการเลือก",
    "moveCanvas": "เคลื่อนย้ายผ้าใบ",
    "cut": "ตัด",
    "copy": "คัดลอก",
    "copyAsPng": "คัดลองไปยังคลิปบอร์ดเป็น PNG",
    "copyAsSvg": "คัดลองไปยังคลิปบอร์ดเป็น SVG",
    "copyText": "คัดลองไปยังคลิปบอร์ดเป็นข้อความ",
    "copySource": "คัดลอกไปยังคลิปบอร์ด",
    "convertToCode": "แปลงไปยังโค้ด",
    "bringForward": "นำขึ้นข้างบน",
    "sendToBack": "ย้ายไปข้างล่าง",
    "bringToFront": "นำขึ้นข้างหน้า",
    "sendBackward": "ย้ายไปข้างหลัง",
    "delete": "ลบ",
    "copyStyles": "คัดลอกรูปแบบ",
    "pasteStyles": "วางรูปแบบ",
    "stroke": "เส้นขอบ",
    "changeStroke": "เปลี่ยนสีเส้น",
    "background": "พื้นหลัง",
    "changeBackground": "เปลี่ยนสีพื้นหลัง",
    "fill": "เติมสี",
    "strokeWidth": "น้ำหนักเส้นขอบ",
    "strokeStyle": "รูปแบบเส้น",
    "strokeStyle_solid": "เส้นทึบ",
    "strokeStyle_dashed": "เส้นประ",
    "strokeStyle_dotted": "จุด",
    "sloppiness": "ความเลอะเทอะ",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "ความทึบแสง",
    "textAlign": "จัดข้อความ",
    "edges": "ขอบ",
    "sharp": "เหลี่ยม",
    "round": "โค้งมน",
    "arrowheads": "หัวลูกศร",
    "arrowhead_none": "ไม่มี",
    "arrowhead_arrow": "ลูกศร",
    "arrowhead_bar": "แถบ",
    "arrowhead_circle": "วงกลม",
    "arrowhead_circle_outline": "วงกลม (เส้นนขอบ)",
    "arrowhead_triangle": "สามเหลี่ยม",
    "arrowhead_triangle_outline": "สามเหลี่ยม (เส้นนขอบ)",
    "arrowhead_diamond": "ขอบเพชร",
    "arrowhead_diamond_outline": "ขอบเพชร (เส้นขอบ)",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "ตัวเลือกเพิ่มเติม",
    "cardinality": "",
    "arrowtypes": "ชนิดลูกศร",
    "arrowtype_sharp": "ลูกศรแหลม",
    "arrowtype_round": "ลูกศรโค้ง",
    "arrowtype_elbowed": "ลูกศรหักมุม",
    "fontSize": "ขนาดตัวอักษร",
    "fontFamily": "แบบตัวอักษร",
    "addWatermark": "เพิ่มลายน้ำ \"สร้างด้วย Excalidraw\"",
    "handDrawn": "ลายมือ",
    "normal": "ปกติ",
    "code": "โค้ด",
    "small": "เล็ก",
    "medium": "กลาง",
    "large": "ใหญ่",
    "veryLarge": "ใหญ่มาก",
    "solid": "เส้นทึบ",
    "hachure": "เส้นลายขวานสับ",
    "zigzag": "ซิกแซก",
    "crossHatch": "เครื่องหมายไขว้",
    "thin": "บาง",
    "bold": "หนา",
    "left": "ซ้าย",
    "center": "กลาง",
    "right": "ขวา",
    "extraBold": "หนาพิเศษ",
    "architect": "สถาปนิก",
    "artist": "ศิลปิน",
    "cartoonist": "นักวาดการ์ตูน",
    "fileTitle": "ชื่อไฟล์",
    "colorPicker": "เลือกสีที่กำหนดเอง",
    "canvasColors": "ใช้บนผืนผ้าใบ",
    "canvasBackground": "พื้นหลังผ้าใบ",
    "drawingCanvas": "กำลังวาดผืนผ้าใบ",
    "clearCanvas": "ล้างผืนผ้าใบ",
    "layers": "เลเยอร์",
    "actions": "การกระทำ",
    "language": "ภาษา",
    "liveCollaboration": "ผู้ทำงานร่วมกันขณะนี้",
    "duplicateSelection": "ทำสำเนา",
    "untitled": "ไม่มีชื่อ",
    "name": "ชื่อ",
    "yourName": "ชื่อของคุณ",
    "madeWithExcalidraw": "เพิ่มลายน้ำ \"สร้างด้วย Excalidraw\"",
    "group": "จัดกลุ่ม",
    "ungroup": "ยกเลิกการจัดกลุ่ม",
    "collaborators": "ผู้ทำงานร่วมกัน",
    "you": "",
    "toggleGrid": "แสดงกริด",
    "loadingScene": "กำลังโหลดฉาก",
    "loadScene": "โหลดฉากจากไฟล์",
    "align": "จัดตำแหน่ง",
    "alignTop": "จัดชิดด้านบน",
    "alignBottom": "จัดชิดด้านล่าง",
    "alignLeft": "จัดชิดซ้าย",
    "alignRight": "จัดชิดขวา",
    "centerVertically": "กึ่งกลางแนวตั้ง",
    "centerHorizontally": "กึ่งกลางแนวนอน",
    "distributeHorizontally": "กระจายแนวนอน",
    "distributeVertically": "กระจายแนวตั้ง",
    "flipHorizontal": "พลิกแนวนอน",
    "flipVertical": "พลิกแนวตั้ง",
    "viewMode": "โหมดมุมมอง",
    "share": "แชร์",
    "showStroke": "แสดงตัวเลือกสีเส้นขอบ",
    "showBackground": "แสดงตัวเลือกสีพื้นหลัง",
    "showFonts": "แสดงตัวเลือกแบบอักษร",
    "toggleTheme": "สลับธีมสว่าง/มืด",
    "theme": "ธีม",
    "decreaseFontSize": "ลดขนาดตัวอักษร",
    "increaseFontSize": "เพิ่มขนาดตัวอักษร",
    "unbindText": "ยกเลิกการผูกติด",
    "bindText": "ผูกข้อความกับที่บรรจุ",
    "createContainerFromText": "จัดข้อความในที่บรรจุ",
    "link": {
      "edit": "แก้ไขลิงก์",
      "editEmbed": "",
      "create": "เพิ่มลิงค์",
      "label": "ลิงค์",
      "labelEmbed": "ลิงค์และการฝัง",
      "empty": "ไม่ได้ใส่ลิงค์",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "แก้ไขเส้น",
      "editArrow": "แก้ไขลูกศร"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "ล็อก",
      "unlock": "ปลดล็อก",
      "lockAll": "ล็อกทั้งหมด",
      "unlockAll": "ปลดล็อกทั้งหมด"
    },
    "sidebarLock": "ปิดแถบด้านข้างเอาไว้",
    "selectAllElementsInFrame": "เลือกองค์ประกอบทั้งหมดในกรอบ",
    "removeAllElementsFromFrame": "ลบองค์ประกอบทั้งหมดในกรอบ",
    "eyeDropper": "เลือกสีผืนผ้าใบ",
    "followUs": "ติดตามเรา",
    "discordChat": "แชทดิสคอร์ด",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "การครอบตัดรูปภาพ",
    "unCroppedDimension": "",
    "copyElementLink": "คัดลอกลิงค์ไปสู่วัตถุ",
    "linkToElement": "ลิงค์ไปสู่วัตถุ",
    "wrapSelectionInFrame": "",
    "tab": "แท็บ",
    "shapeSwitch": "",
    "preferences": "การตั้งค่า",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "ลิงค์ไปสู่วัตถุ",
    "desc": "",
    "notFound": ""
  },
  "search": {
    "title": "ใช้บนผืนผ้าใบ",
    "noMatch": "ไม่พบรายการที่ตรงกัน...",
    "singleResult": "ผลลัพธ์",
    "multipleResults": "ผลลัพธ์",
    "placeholder": "ค้นหาข้อความในผืนผ้าใบ",
    "frames": "กรอบ",
    "texts": "ข้อความ"
  },
  "buttons": {
    "clearReset": "รีเซ็ทผืนผ้าใบ",
    "exportJSON": "ส่งออกไปยังไฟล์",
    "exportImage": "ส่งออกเป็นรูปภาพ",
    "export": "บันทึกไปยัง",
    "copyToClipboard": "คัดลอกไปยังคลิปบอร์ด",
    "copyLink": "คัดลอกลิงก์",
    "save": "บันทึกเป็นไฟล์ปัจจุบัน",
    "saveAs": "บันทึกเป็น",
    "load": "เปิด",
    "getShareableLink": "สร้างลิงค์ที่แชร์ได้",
    "close": "ปิด",
    "selectLanguage": "เลือกภาษา",
    "scrollBackToContent": "เลื่อนกลับไปด้านบน",
    "zoomIn": "ซูมเข้า",
    "zoomOut": "ซูมออก",
    "resetZoom": "รีเซ็ตการซูม",
    "menu": "เมนู",
    "done": "เสร็จสิ้น",
    "edit": "แก้ไข",
    "undo": "เลิกทำ",
    "redo": "ทำซ้ำ",
    "createNewRoom": "สร้างห้องใหม่",
    "fullScreen": "เต็มหน้าจอ",
    "darkMode": "โหมดกลางคืน",
    "lightMode": "โหมดกลางวัน",
    "systemMode": "",
    "zenMode": "โหมด Zen",
    "objectsSnapMode": "",
    "exitZenMode": "ออกจากโหมด Zen",
    "cancel": "ยกเลิก",
    "clear": "เคลียร์",
    "remove": "ลบ",
    "embed": "สลับการฝัง",
    "submit": "ตกลง",
    "confirm": "ยืนยัน",
    "embeddableInteractionButton": "คลิกเพื่อปฏิสัมพันธ์"
  },
  "alerts": {
    "clearReset": "",
    "couldNotCreateShareableLink": "ไม่สามารถสร้างลิงค์ได้",
    "couldNotCreateShareableLinkTooBig": "",
    "couldNotLoadInvalidFile": "ไม่สามารถโหลดไฟล์ที่ผิดพลาดได้",
    "importBackendFailed": "เกิดข้อผิดพลาดจากการนำเข้าจากระบบหลังบ้าน",
    "cannotExportEmptyCanvas": "ไม่สามารถนำออกจากผืนผ้าใบที่ว่างเปล่าได้",
    "couldNotCopyToClipboard": "ไม่สามารถคัดลอกไปยังคลิปบอร์ดได้",
    "decryptFailed": "ไม่สามารถถอดรหัสข้อมูลได้",
    "uploadedSecurly": "การอัพโหลดได้ถูกเข้ารหัสแบบ end-to-end หมายความว่าเซิร์ฟเวอร์ของ Excalidraw และบุคคลอื่นไม่สามารถอ่านข้อมูลได้",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "",
    "invalidSceneUrl": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "ไม่รองรับชนิดของไฟล์นี้",
    "imageInsertError": "ไม่สามารถเพิ่มรูปภาพได้ ลองอีกครั้งในภายหลัง",
    "fileTooBig": "",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "ไม่สามารถเชื่อต่อกับ collab เซิร์ฟเวอร์ได้ โปรดลองโหลดหน้านี้ใหม่และลองอีกครั้ง",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "ไม่สามารถวางได้",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "การเลือก",
    "lasso": "การเลือก Lasso",
    "image": "แทรกรูปภาพ",
    "rectangle": "สี่เหลี่ยมผืนผ้า",
    "diamond": "รูปเพชร",
    "ellipse": "วงรี",
    "arrow": "ลูกศร",
    "line": "เส้น",
    "freedraw": "เขียนรูป",
    "text": "ข้อความ",
    "lock": "",
    "penMode": "",
    "link": "เพิ่ม / อัปเดตลิงก์สำหรับรูปร่างที่เลือก",
    "eraser": "ยางลบ",
    "frame": "เครื่องมือกรอบ",
    "embeddable": "ฝังเว็บ",
    "laser": "ตัวชี้เลเซอร์",
    "autoshape": "",
    "bucketfill": "",
    "hand": "มือ (เครื่องมือเลื่อน)",
    "extraTools": "เครื่องมืออื่นๆ",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "สี่เหลี่ยม",
    "diamond": "รูปเพชร",
    "ellipse": "วงรี",
    "arrow": "ลูกศร",
    "line": "เส้น",
    "freedraw": "วาดอิสระ",
    "text": "ข้อความ",
    "image": "รูปภาพ",
    "group": "จัดกลุ่ม",
    "frame": "กรอบ",
    "embeddable": "ฝังเว็บ",
    "selection": "การเลือก",
    "iframe": "ไอเฟรม"
  },
  "headings": {
    "canvasActions": "การกระทำบนผืนผ้าใบ",
    "selectedShapeActions": "การกระทำกับรูปร่างที่เลือก",
    "shapes": "รูปร่าง"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "คลิกเพื่อเริ่มหลายจุด ลากสำหรับเส้นเดียว",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "",
    "text": "",
    "embeddable": "คลิกและลากเพื่อสร้างการฝังสำหรับเว็บไซต์",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "",
    "canvasTooBig": "",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "<button>กำลังรีโหลดหน้า</button>",
    "clearCanvasMessage": "ถ้าโหลดไม่ได้ ให้ลอง <button>เคลียร์ผืนผ้าใบ</button>",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "เริ่มเซสชัน",
    "button_stopSession": "หยุดเซสชัน",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "ข้อผิดพลาด"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "บันทึกไปยังดิสก์",
    "disk_details": "",
    "disk_button": "บันทึกเป็นไฟล์",
    "link_title": "ลิงก์ที่สามารถแชร์ได้",
    "link_details": "",
    "link_button": "ส่งออกไปยังไฟล์",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "ส่งออก",
    "excalidrawplus_exportError": "ไม่สามารถส่งออกไปที่ Excalidraw+ ได้ในขณะนี้"
  },
  "helpDialog": {
    "blog": "อ่านบล็อกของพวกเรา",
    "click": "คลิก",
    "deepSelect": "การเลือเชิงลึก",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "ลูกศรโค้ง",
    "curvedLine": "เส้นโค้ง",
    "documentation": "เอกสารคู่มือ",
    "doubleClick": "ดับเบิลคลิก",
    "drag": "ลาก",
    "editor": "ตัวแก้ไข",
    "editLineArrowPoints": "",
    "editText": "แก้ไขข้อความ / เพิ่มข้อความ",
    "github": "",
    "howto": "",
    "or": "หรือ",
    "preventBinding": "",
    "tools": "เครื่องมือ",
    "shortcuts": "แป้นพิมพ์ลัด",
    "textFinish": "",
    "textNewLine": "",
    "title": "ช่วยเหลือ",
    "view": "ดู",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "ย้ายหน้าไปด้าน ซ้าย/ขวา",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "ล้างผืนผ้าใบ"
  },
  "imageExportDialog": {
    "header": "ส่งออกเป็นรูปภาพ",
    "label": {
      "withBackground": "พื้นหลัง",
      "onlySelected": "เฉพาะที่เลือก",
      "darkMode": "โหมดกลางคืน",
      "embedScene": "",
      "scale": "อัตราส่วน",
      "padding": "การเว้นระยะ"
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "ส่งออกไปเป็น SVG",
      "exportToSvg": "ส่งออกไปเป็น SVG",
      "copyPngToClipboard": "คัดลอก PNG ไปยังคลิปบอร์ด"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "คัดลอกไปยังคลิปบอร์ด"
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "องศา",
    "shapes": "รูปร่าง",
    "height": "ความสูง",
    "scene": "ฉาก",
    "selected": "ถูกเลือกแล้ว",
    "storage": "การจัดเก็บข้อมูล",
    "fullTitle": "",
    "title": "คุณสมบัติ",
    "generalStats": "ทั่วไป",
    "elementProperties": "",
    "total": "รวมทั้งหมด",
    "version": "เวอร์ชั่น",
    "versionCopy": "คลิกเพื่อคัดลอก",
    "versionNotAvailable": "",
    "width": "ความกว้าง"
  },
  "toast": {
    "copyStyles": "คัดลอกรูปแบบสำเร็จแล้ว",
    "copyToClipboard": "คัดลอกไปยังคลิปบอร์ดแล้ว",
    "copyToClipboardAsPng": "",
    "copyToClipboardAsSvg": "",
    "fileSaved": "ข้อมูลได้รับการบันทึก",
    "fileSavedToFilename": "บันทึกเป็น {filename}",
    "canvas": "ผืนผ้าใบ",
    "selection": "การเลือก",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": "คัดลอกไปยังคลิปบอร์ดแล้ว"
  },
  "colors": {
    "transparent": "โปร่งใส",
    "black": "สีดำ",
    "white": "สีขาว",
    "red": "สีแดง",
    "pink": "สีชมพู",
    "grape": "สีองุ่น",
    "violet": "สีม่วง",
    "gray": "สีเทา",
    "blue": "สีน้ำเงิน",
    "cyan": "สีฟ้าอมเขียว",
    "teal": "ฟ้าน้ำทะเล",
    "green": "เขียว",
    "yellow": "เหลือง",
    "orange": "ส้ม",
    "bronze": "ทองแดง"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": "ทางลัดและการช่วยเหลือ"
    }
  },
  "colorPicker": {
    "color": "สี",
    "mostUsedCustomColors": "",
    "colors": "สี",
    "shades": "รูปร่าง",
    "hexCode": "Hex code",
    "noShades": "",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "ส่งออกเป็นภาพ",
        "button": "ส่งออกเป็นภาพ",
        "description": ""
      },
      "saveToDisk": {
        "title": "บันทึกไปยังดิสก์",
        "button": "บันทึกไปยังดิสก์",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "นำออกไปยัง Excalidraw+",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "โหลดจากไฟล์",
        "button": "โหลดจากไฟล์",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "แทนที่เนื้อหาของฉัน",
        "description": ""
      }
    }
  },
  "quickSearch": {
    "placeholder": "ค้นหาด่วน"
  },
  "fontList": {
    "badge": {
      "old": "เก่า"
    },
    "sceneFonts": "ในฉากนี้",
    "availableFonts": "",
    "empty": "ไม่พบแบบอักษร"
  },
  "userList": {
    "empty": "ไม่พบผู้ใช้",
    "hint": {
      "text": "คลิกที่ผู้ใช้เพื่อติดตาม",
      "followStatus": "คุณกำลังติดตามผู้ใช้นี้",
      "inCall": "ผู้ใช้นี้กำลังอยู่ในการโทรด้วยเสียง",
      "micMuted": "ไมโครโฟนของผู้ใช้ถูกปิดเสียง",
      "isSpeaking": "ผู้ใช้งานกำลังสนทนาอยู่"
    }
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Option",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Enter",
    "shift": "เลื่อน",
    "spacebar": "อวกาศ",
    "delete": "ลบ",
    "mmb": ""
  }
}
